import React, { Component } from "react";
import { observer } from "mobx-react";

import { Heading3 } from "../../common/Heading3";
import { Total } from "./Total";
import { UsageItem } from "./UsageItem";

export interface IUsageCountProps {
    title: string;
    count: number | string;
    cost?: number;
}

@observer
export class UsageCount extends Component<IUsageCountProps> {
    public render() {
        const { title, count, cost } = this.props;

        return (
            <UsageItem large={true}>
                <Heading3>{title}</Heading3>
                <Total
                    label={
                        cost !== undefined ? `$${cost.toFixed(2)}` : undefined
                    }
                >
                    {count}
                </Total>
            </UsageItem>
        );
    }
}
